import { plainTextTitle } from './noteTitle'

export interface OutlineItem {
  /** ATX heading level, 1-6. */
  level: number
  /** Heading text with inline markdown stripped (via plainTextTitle). */
  text: string
  /** Zero-based line index in the markdown source. */
  line: number
}

// CommonMark ATX heading: up to 3 leading spaces, 1-6 hashes, then a space
// (or end of line). Mirrored byte-for-byte by MarkdownOutline.swift in
// CaliuCore. Change here AND there, or neither.
const ATX_HEADING = /^ {0,3}(#{1,6})(?:\s+(.*))?$/

/**
 * Extract the heading outline from markdown. Skips fenced code blocks
 * (``` or ~~~), including unclosed fences running to EOF. Heading text is
 * normalized to plain readable text with plainTextTitle.
 */
export function extractOutline(content: string): OutlineItem[] {
  const items: OutlineItem[] = []
  const lines = content.split('\n')
  let inFence = false
  let fenceChar = ''

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]
    const fenceMatch = line.match(/^ {0,3}(`{3,}|~{3,})/)
    if (fenceMatch) {
      const char = fenceMatch[1][0]
      if (!inFence) {
        inFence = true
        fenceChar = char
      } else if (char === fenceChar) {
        inFence = false
      }
      continue
    }
    if (inFence) continue

    const match = line.match(ATX_HEADING)
    if (!match) continue
    const rawText = (match[2] ?? '').trim()
    if (!rawText) continue
    items.push({
      level: match[1].length,
      text: plainTextTitle(rawText),
      line: i,
    })
  }
  return items
}
